/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".alias-question[_ngcontent-%COMP%]{position:relative;margin-bottom:20px}.alias-question__item[_ngcontent-%COMP%]{position:relative;color:var(--link-color);text-decoration:none;font-size:18px;font-weight:600;font-style:normal;line-height:1.39;vertical-align:top;margin:0 0 12px;display:block}"];
export { styles as styles };
